import Vue from 'vue'
//import * as firebase from 'firebase'
import firebase from 'firebase/app';
import 'firebase/auth'
import 'firebase/database'
import 'firebase/firestore'
// import 'firebase/messaging'
// import 'firebase/functions'
import { store } from '../store'
import DATA from './DATA'
import DB from './DB';
let PAGE_NAME = 'INITIATE_FIREBASE'

new Vue({
  firebase,
  store,
  async created() {
     
    firebase.initializeApp(DATA.APP.key)

    await store.dispatch('initialize_users_ref')
    await store.dispatch('initialize_items_ref') 

    //----------- LOGIN USER----------------- 
    store.dispatch('setLoading', true)
    store.dispatch('setProcesses', {
      add: true,
      name: 'logging'
    })
    firebase.auth().onAuthStateChanged(async user => {
      let date = new Date() 
      // store.dispatch('setLoggedTime',date)
      store.dispatch('setUser',user)
      store.dispatch('setProcesses', { 
        name: 'logging'
      })  
      if (user) {
        store.dispatch('initializeUserByUidRef') 
        store.dispatch('connectUser',{user:user}) 
        await DB.addItems({
          name:DATA.ITEMS.USER_LIVES.values,
          data:{
            key:DATA.APP.USER_TIMELINE.current,
            date:date,
            uid:user.uid 
          },
        }) 
        await DB.deleteItems({
          name:DATA.ITEMS.USER_LIVES.values,
          key:DATA.APP.USER_TIMELINE.logged_out
        })
  
        store.dispatch('fi_get_user_items',{
          name:DATA.ITEMS.USERS.values,
          on:true,
        }) 
        store.dispatch('fi_get_user_items',{
          name:DATA.ITEMS.USER_STATUSES.values,
          on:true,
          
        }) 
        store.dispatch('fi_get_user_items',{
          name:DATA.ITEMS.USER_GROUPS.values,
          on:true, 
          cash:true, 
          get:true,
        })   
      }
      // store.dispatch('setUser', user)
      // store.dispatch('setProcesses', { 
      //   name: 'logging'
      // }) 
      // if (user) {
      //   store.dispatch('fi_getOn_userD')
      //   store.dispatch('fi_getOn_user_group')
      //   store.dispatch('fi_getOn_users') 

      // }
    })
    //SETTINGS
    store.dispatch('fi_get_user_items',{
      name:DATA.ITEMS.PERMISSIONS.values,
      on:true, 
      cash:true, 
      get:true, 
    }) 
    
    store.dispatch('fi_getOn_question_checklists')
    store.dispatch('fi_getOn_question_responses')
    store.dispatch('fi_getOn_question_stages')
    store.dispatch('fi_getOn_question_categories')
    store.dispatch('fi_getOn_question_types')
    store.dispatch('fi_getOn_question_timelines')
 

    store.dispatch('fi_getOn_submitted_results_level')
    store.dispatch('fi_getOn_district_results') 
    store.dispatch('fi_getOn_district_results_details') 
    store.dispatch('fi_getOn_constituency_results') 
    store.dispatch('fi_getOn_constituency_results_details') 
    store.dispatch('fi_getOn_ward_results') 
    store.dispatch('fi_getOn_ward_results_details') 
    store.dispatch('fi_getOn_centre_results') 
    store.dispatch('fi_getOn_centre_results_details')  
  },
})
